/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 6HBcNwr8dz9LuS1Qe36xa5
// Component: ZGdhyEBPJSmH

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { Dialog } from "@plasmicpkgs/radix-ui";
import Paziresh24Button from "../../Paziresh24Button"; // plasmic-import: YOhw5fIQJQgB/component
import { DialogContent } from "@plasmicpkgs/radix-ui";
import { DialogTitle } from "@plasmicpkgs/radix-ui";
import { DialogClose } from "@plasmicpkgs/radix-ui";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 6HBcNwr8dz9LuS1Qe36xa5/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 6HBcNwr8dz9LuS1Qe36xa5/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "../launcher/plasmic.module.css"; // plasmic-import: 6HBcNwr8dz9LuS1Qe36xa5/projectcss
import sty from "./PlasmicPaziresh24Modal.module.css"; // plasmic-import: ZGdhyEBPJSmH/css

import ChevronRightIcon from "./icons/PlasmicIcon__ChevronRight"; // plasmic-import: 0359howWu0cr/icon
import ChevronLeftIcon from "./icons/PlasmicIcon__ChevronLeft"; // plasmic-import: jS0YlkKPLO7U/icon
import XIcon from "./icons/PlasmicIcon__X"; // plasmic-import: TbYkPSJXy2Wa/icon

createPlasmicElementProxy;

export type PlasmicPaziresh24Modal__VariantMembers = {
  noTrigger: "noTrigger";
  hideHeader: "hideHeader";
  noSpacing: "noSpacing";
  fullScreen: "fullScreen";
};
export type PlasmicPaziresh24Modal__VariantsArgs = {
  noTrigger?: SingleBooleanChoiceArg<"noTrigger">;
  hideHeader?: SingleBooleanChoiceArg<"hideHeader">;
  noSpacing?: SingleBooleanChoiceArg<"noSpacing">;
  fullScreen?: SingleBooleanChoiceArg<"fullScreen">;
};
type VariantPropType = keyof PlasmicPaziresh24Modal__VariantsArgs;
export const PlasmicPaziresh24Modal__VariantProps = new Array<VariantPropType>(
  "noTrigger",
  "hideHeader",
  "noSpacing",
  "fullScreen"
);

export type PlasmicPaziresh24Modal__ArgsType = {
  open?: boolean;
  onOpenChange?: (val: boolean) => void;
  trigger?: React.ReactNode;
  title?: React.ReactNode;
  body?: React.ReactNode;
};
type ArgPropType = keyof PlasmicPaziresh24Modal__ArgsType;
export const PlasmicPaziresh24Modal__ArgProps = new Array<ArgPropType>(
  "open",
  "onOpenChange",
  "trigger",
  "title",
  "body"
);

export type PlasmicPaziresh24Modal__OverridesType = {
  dialog?: Flex__<typeof Dialog>;
  dialogContent?: Flex__<typeof DialogContent>;
  dialogTitle?: Flex__<typeof DialogTitle>;
  h5?: Flex__<"h5">;
  dialogClose?: Flex__<typeof DialogClose>;
  svg?: Flex__<"svg">;
};

export interface DefaultPaziresh24ModalProps {
  open?: boolean;
  onOpenChange?: (val: boolean) => void;
  trigger?: React.ReactNode;
  title?: React.ReactNode;
  body?: React.ReactNode;
  noTrigger?: SingleBooleanChoiceArg<"noTrigger">;
  hideHeader?: SingleBooleanChoiceArg<"hideHeader">;
  noSpacing?: SingleBooleanChoiceArg<"noSpacing">;
  fullScreen?: SingleBooleanChoiceArg<"fullScreen">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicPaziresh24Modal__RenderFunc(props: {
  variants: PlasmicPaziresh24Modal__VariantsArgs;
  args: PlasmicPaziresh24Modal__ArgsType;
  overrides: PlasmicPaziresh24Modal__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "dialog.open",
        type: "writable",
        variableType: "boolean",

        valueProp: "open",
        onChangeProp: "onOpenChange"
      },
      {
        path: "noTrigger",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.noTrigger
      },
      {
        path: "hideHeader",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.hideHeader
      },
      {
        path: "noSpacing",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.noSpacing
      },
      {
        path: "fullScreen",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.fullScreen
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <Dialog
      data-plasmic-name={"dialog"}
      data-plasmic-override={overrides.dialog}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "__wab_instance",
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.dialog,
        {
          [sty.dialogfullScreen]: hasVariant(
            $state,
            "fullScreen",
            "fullScreen"
          ),
          [sty.dialoghideHeader]: hasVariant(
            $state,
            "hideHeader",
            "hideHeader"
          ),
          [sty.dialognoSpacing]: hasVariant($state, "noSpacing", "noSpacing"),
          [sty.dialognoTrigger]: hasVariant($state, "noTrigger", "noTrigger")
        }
      )}
      onOpenChange={async (...eventArgs: any) => {
        generateStateOnChangeProp($state, ["dialog", "open"]).apply(
          null,
          eventArgs
        );
      }}
      open={generateStateValueProp($state, ["dialog", "open"])}
      overlayClassName={classNames({
        [sty["pcls_46s5uGOGxgpk"]]: true,
        [sty["pcls_K6_vOzWda3xT"]]: hasVariant(
          globalVariants,
          "screen",
          "mobileOnly"
        ),
        [sty["pcls_WDihk6kCe0ji"]]: hasVariant(
          $state,
          "fullScreen",
          "fullScreen"
        ),
        [sty["pcls_h1JMcb3kaBFw"]]:
          hasVariant($state, "fullScreen", "fullScreen") &&
          hasVariant(globalVariants, "screen", "mobileOnly")
      })}
      themeResetClass={classNames(
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames
      )}
      triggerSlot={
        (hasVariant($state, "noTrigger", "noTrigger") ? false : true)
          ? renderPlasmicSlot({
              defaultContents: (
                <Paziresh24Button
                  children2={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__wgcRz
                      )}
                    >
                      {"Show Modal"}
                    </div>
                  }
                  endIcon={
                    <ChevronLeftIcon
                      className={classNames(projectcss.all, sty.svg__yh3Uc)}
                      role={"img"}
                    />
                  }
                  startIcon={
                    <ChevronRightIcon
                      className={classNames(projectcss.all, sty.svg__uDsY2)}
                      role={"img"}
                    />
                  }
                />
              ),

              value: args.trigger
            })
          : null
      }
    >
      <DialogContent
        data-plasmic-name={"dialogContent"}
        data-plasmic-override={overrides.dialogContent}
        className={classNames("__wab_instance", sty.dialogContent, {
          [sty.dialogContentfullScreen]: hasVariant(
            $state,
            "fullScreen",
            "fullScreen"
          ),
          [sty.dialogContenthideHeader]: hasVariant(
            $state,
            "hideHeader",
            "hideHeader"
          ),
          [sty.dialogContentnoSpacing]: hasVariant(
            $state,
            "noSpacing",
            "noSpacing"
          )
        })}
        themeResetClass={classNames(
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames
        )}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__ckToi, {
            [sty.freeBoxhideHeader__ckToi1Okbm]: hasVariant(
              $state,
              "hideHeader",
              "hideHeader"
            )
          })}
          dir={``}
        >
          <DialogTitle
            data-plasmic-name={"dialogTitle"}
            data-plasmic-override={overrides.dialogTitle}
            className={classNames("__wab_instance", sty.dialogTitle)}
          >
            <h5
              data-plasmic-name={"h5"}
              data-plasmic-override={overrides.h5}
              className={classNames(projectcss.all, projectcss.h5, sty.h5)}
            >
              {renderPlasmicSlot({
                defaultContents: "Title",
                value: args.title,
                className: classNames(sty.slotTargetTitle)
              })}
            </h5>
          </DialogTitle>
        </div>
        <div
          className={classNames(projectcss.all, sty.freeBox___1Wayd, {
            [sty.freeBoxhideHeader___1Wayd1Okbm]: hasVariant(
              $state,
              "hideHeader",
              "hideHeader"
            )
          })}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___8Xy9A
                )}
              >
                {"You can insert body content here in this slot."}
              </div>
            ),
            value: args.body
          })}
        </div>
        <DialogClose
          data-plasmic-name={"dialogClose"}
          data-plasmic-override={overrides.dialogClose}
          className={classNames("__wab_instance", sty.dialogClose, {
            [sty.dialogClosehideHeader]: hasVariant(
              $state,
              "hideHeader",
              "hideHeader"
            )
          })}
        >
          <XIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg)}
            role={"img"}
          />
        </DialogClose>
      </DialogContent>
    </Dialog>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  dialog: [
    "dialog",
    "dialogContent",
    "dialogTitle",
    "h5",
    "dialogClose",
    "svg"
  ],
  dialogContent: ["dialogContent", "dialogTitle", "h5", "dialogClose", "svg"],
  dialogTitle: ["dialogTitle", "h5"],
  h5: ["h5"],
  dialogClose: ["dialogClose", "svg"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  dialog: typeof Dialog;
  dialogContent: typeof DialogContent;
  dialogTitle: typeof DialogTitle;
  h5: "h5";
  dialogClose: typeof DialogClose;
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPaziresh24Modal__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPaziresh24Modal__VariantsArgs;
    args?: PlasmicPaziresh24Modal__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicPaziresh24Modal__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicPaziresh24Modal__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPaziresh24Modal__ArgProps,
          internalVariantPropNames: PlasmicPaziresh24Modal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPaziresh24Modal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "dialog") {
    func.displayName = "PlasmicPaziresh24Modal";
  } else {
    func.displayName = `PlasmicPaziresh24Modal.${nodeName}`;
  }
  return func;
}

export const PlasmicPaziresh24Modal = Object.assign(
  // Top-level PlasmicPaziresh24Modal renders the root element
  makeNodeComponent("dialog"),
  {
    // Helper components rendering sub-elements
    dialogContent: makeNodeComponent("dialogContent"),
    dialogTitle: makeNodeComponent("dialogTitle"),
    h5: makeNodeComponent("h5"),
    dialogClose: makeNodeComponent("dialogClose"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicPaziresh24Modal
    internalVariantProps: PlasmicPaziresh24Modal__VariantProps,
    internalArgProps: PlasmicPaziresh24Modal__ArgProps
  }
);

export default PlasmicPaziresh24Modal;
/* prettier-ignore-end */
